import { useEffect, useState } from 'react';

import { useFocus } from '@app/hooks/useFocus';
import { Row } from '@app/utils/epgUtils';
import { getFieldOnMainLanguage } from '@app/utils/languages';
import { Autocomplete, Dialog, TextField } from '@mui/material';

interface SelectEditorProps {
  row: any;
  column: any;
  onRowChange(row: Row, value: boolean): void;
  onClose(): void;
}

export const SelectEditor = ({ row, column, onRowChange, onClose }: SelectEditorProps) => {
  const { htmlElRef, setFocus } = useFocus();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setFocus();
  }, [htmlElRef, setFocus]);

  const onKeyDown = (e: any) => {
    const keyCode = e.code;

    if (keyCode === 'Enter' || keyCode === 'Backspace') {
      e.stopPropagation();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Dialog onClose={onClose} open>
      <div style={{ padding: 15, width: 600 }}>
        <Autocomplete
          onKeyDown={onKeyDown}
          value={row[column.key]}
          getOptionLabel={(option) =>
            column.label ? getFieldOnMainLanguage(option[column.label]) : column?.getLabel(option)
          }
          onChange={(event: any, newValue) => {
            onRowChange({ ...row, [column.key]: newValue }, true);
          }}
          onClose={handleClose}
          onOpen={handleOpen}
          open={open}
          options={column.source}
          fullWidth
          // eslint-disable-next-line jsx-a11y/no-autofocus
          renderInput={(params) => <TextField {...params} autoFocus ref={htmlElRef} label={column.name} />}
        />
      </div>
    </Dialog>
  );
};
